'use client';

import React, { useState, useEffect } from 'react';
import { Input } from '@/components/ui/input';
import { BaseDialog } from '@/components/shared/base-dialog';

interface GroupNameDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (name: string) => void;
  /** If provided, pre-fills the input for renaming */
  initialName?: string;
  mode: 'create' | 'rename';
}

export function GroupNameDialog({
  isOpen,
  onOpenChange,
  onConfirm,
  initialName = '',
  mode,
}: GroupNameDialogProps) {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isOpen) {
      setName(initialName);
    }
  }, [isOpen, initialName]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
    onOpenChange(false);
  };

  return (
    <BaseDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={mode === 'create' ? 'New Group' : 'Rename Group'}
      description={
        mode === 'create'
          ? 'Give your project group a name.'
          : 'Enter a new name for this group.'
      }
      onSubmit={handleSubmit}
      confirmLabel={mode === 'create' ? 'Create' : 'Rename'}
      confirmDisabled={!name.trim()}
    >
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Group name..."
        autoFocus
        maxLength={100}
      />
    </BaseDialog>
  );
}
